<template>
  <RouterView />
  <Toasts />
</template>

<script src="./app.view.ts" lang="ts" />
